import {
    // setCookie,
    // initializeMap,
    initMenuTrigger,
    //initOpenInNewTab,
    //aosConfig,
    addScollClass,
    // addFancyboxFixForGallery,
    initGallerySlider,
    //addCloseCookies,
    initForm,
    //  googleMapInit,
    // initLoadNews,
    faqService,
    initLazyBg,
    initShow
} from './functions';

import wcQuantity from './wcQuantity';


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow();

    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    // initOpenInNewTab();

    // init AOS animation config
    // aosConfig();

    // add scroll class to body  
    addScollClass('100px', 'scroll');



    //fix gallery id for slideshow
    // addFancyboxFixForGallery('.wp-block-gallery');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    // addCloseCookies();



    //start - contact form
    initForm();

    //googleMapInit();


    //initLoadNews();

    faqService();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {

        //rotator and sliders

        if ($('.gReferences__slider').length > 0) {

            if ("IntersectionObserver" in window) {
                let lazyslider = [].slice.call(document.querySelectorAll('.gReferences__slider'));
                let lazysliderObserver = new IntersectionObserver(function (entries, observer) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            $('.gReferences__slider').slick({
                                infinite: true,
                                arrows: true,
                                dots: true,
                                autoplay: false,
                                speed: 500,
                                autoplaySpeed: 3000,
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                responsive: [
                                    {
                                        breakpoint: 1200,
                                        settings: {
                                            slidesToShow: 3,
                                        }
                                    },
                                    {
                                        breakpoint: 768,
                                        settings: {
                                            slidesToShow: 2,
                                        }
                                    },
                                    {
                                        breakpoint: 480,
                                        settings: {
                                            slidesToShow: 1,
                                        }
                                    }
                                ]
                            });
                            lazysliderObserver.unobserve(entry.target);
                        }
                    });
                }, {
                    rootMargin: '600px 0px'
                });
                lazyslider.forEach(function (ls) {
                    lazysliderObserver.observe(ls);
                });
            }



        }
        if ($('.gProducts__list').length > 0) {
            if ("IntersectionObserver" in window) {
                let lazysliderP = [].slice.call(document.querySelectorAll('.gProducts__list'));
                let lazysliderObserverP = new IntersectionObserver(function (entries, observer) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            $('.gProducts__list').slick({
                                infinite: true,
                                arrows: true,
                                dots: true,
                                autoplay: false,
                                speed: 500,
                                autoplaySpeed: 3000,
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                responsive: [
                                    {
                                        breakpoint: 992,
                                        settings: {
                                            slidesToShow: 3,
                                        }
                                    },
                                    {
                                        breakpoint: 768,
                                        settings: {
                                            slidesToShow: 2,
                                        }
                                    },
                                    {
                                        breakpoint: 480,
                                        settings: {
                                            slidesToShow: 1,
                                        }
                                    }
                                ]
                            });
                            lazysliderObserverP.unobserve(entry.target);
                        }
                    });
                }, {
                    rootMargin: '600px 0px'
                });
                lazysliderP.forEach(function (ls) {
                    lazysliderObserverP.observe(ls);
                });
            }




        }

        $('.row.przyciski a[href^="tel:"]').on('click', function (e) {
            if (window.innerWidth > 1200) {
                e.preventDefault();
                return false;
            }

        });



        function scroll_to_hash(hash) {
            var hash = hash ? hash : window.location.hash;

            if ($(hash).length) {
                setTimeout(() => {
                    $('html, body').animate({
                        scrollTop: $(hash).offset().top - 160
                    }, 900, 'swing');
                }, 10);

            }
        }


        if (window.location.hash) {
            window.scrollTo(0, 0);
            scroll_to_hash();
        }
        $('.product_menu a').on('click', function (e) {
            e.preventDefault();
            var hash = $(this).attr('href');
            scroll_to_hash(hash);
            setTimeout(() => {
                window.location.hash = hash;
            }, 10);
            return false;
        });


        $('.subpageHeader__goDown').click(function () {
            $('html,body').animate({ 'scrollTop': ($(this).offset().top - $(this).height()) + 'px' }, 500);
        });

        $(document).on('click', '.mainHeader__menu .has-children', function (e) {
            if (window.innerWidth < 1200) {
                e.stopPropagation();
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(this).parent().addClass('activeParent');
                    $('.mainHeader__menuBack').addClass('show');

                    $('.mainHeader__menuHolder').animate({ 'scrollTop': '0px' }, 0);
                } else {
                    $(this).removeClass('active');
                    $(this).parent().removeClass('activeParent');
                }
            }
        });


        $(document).on('click', '.mainHeader__menu .menu__subItem', function (e) {
            $(this).siblings().removeClass('show_pc');
            $(this).addClass('show_pc');

        });

        $(document).on('click', '.mainHeader__menuBack', function () {
            $('.activeParent:last').removeClass('activeParent');
            $('.mainHeader__menu .menu__item.active:last').removeClass('active');
            if ($('.mainHeader__menu .menu__item.active:last').length > 0) {
                // $('.mainHeader__menuBack').html($('.menu__item.active:last').find('>a').html());
            } else {
                // $('.mainHeader__menuBack').html('');
                $('.mainHeader__menuBack').removeClass('show');
            }
        });
        $(document).on('click', '.menuTrigger', function () {
            $('.activeParent').removeClass('activeParent');
            $('.mainHeader__menu .menu__item.active').removeClass('active');
            $('.mainHeader__menuBack').removeClass('show');

        });


        $('.mainHeader__menu  a[href*="|"]').each(function (e) {

            let url = $(this).attr('href');
            let split_url = url.split('|');
            if (window.innerWidth <= 782) {
                $(this).attr('href', split_url[0]);
            } else {
                $(this).attr('href', split_url[1]);
            }
        });

        $('.is-style-btnSimpleMenu a').on('click', function (e) {
            e.preventDefault();
            let url = $(this).attr('href');
            if (!url) return;
            let anchor = $(url).offset().top;
            if (!anchor) return;
            $('html,body').animate({ 'scrollTop': (anchor - (window.innerWidth > 1200 ? 150 : 100)) + 'px' }, 500);
            return false;
        });

        $('.expert_duty').on('click', function (e) {
            e.preventDefault();
            let popup = $('.expert_duty_popup');
            if (popup.hasClass('active')) {
                popup.removeClass('active');
                $('body').removeClass('overflowHidden');
            } else {
                popup.addClass('active');
                $('body').addClass('overflowHidden');
                return false;
            }
        });
        $('.free_consultation').on('click', function (e) {
            e.preventDefault();
            let popup = $('.free_consultation_popup');
            if (popup.hasClass('active')) {
                popup.removeClass('active');
                $('body').removeClass('overflowHidden');
            } else {
                popup.addClass('active');
                $('body').addClass('overflowHidden');
                return false;
            }
        });
        $('.gPopup__close').on('click', function (e) {
            $(this).parents('.gPopup').removeClass('active');
            $('body').removeClass('overflowHidden');
        });
        $('.gPopup').on('click', function (e) {
            $(this).removeClass('active');
            $('body').removeClass('overflowHidden');
        });

        $('.gPopup__inner').on('click', function (e) {
            e.stopPropagation();
        });


        $('.productCategoryMenu__item').on('click', function (e) {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            } else if ($(this).find('.productCategoryMenu__sublist').length > 0) {
                $(this).addClass('active');
                $('.productCategoryMenu__item').not(this).removeClass('active');
            }
        });
        $('.productCategoryMenu__sublist').on('click', function (e) {

            e.stopPropagation();

        });


        $('.mainHeader__searchTrigger').click(function () {
            document.querySelector('.mainHeader__search').classList.toggle('show');
            document.querySelector('.mainHeader__searchTrigger').classList.toggle('show');
        });



        if ($('.woocommerce-product-gallery__wrapper').length > 0) {
            $('.woocommerce-product-gallery__wrapper').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 10000,
                mobileFirst: true,
                /* responsive: [
                     {
                         breakpoint: 640,
                         settings: 'unslick'
                     }
                 ]
                 */
            });

        }

        $('.woocommerce-product-gallery__image a').on('click', function (e) {
            e.preventDefault();

            if ($(this).find('.imageBig').length > 0) {
                $(this).find('.imageBig').remove();
                return false;
            }
            // if (window.innerWidth < 782 || (window.innerWidth >= 782 && ) {
            console.log('click');
            const url = $(this).attr('href');
            const imageBig = $('<img src="' + url + '" class="imageBig" />');
            const parentTop = $(this).offset().top;
            const parentLeft = $(this).offset().left;
            const parentWidth = $(this).width();
            const parentHeight = $(this).height();


            function mMove(e) {
                const cx = e.pageX;
                const cy = e.pageY;
                const leftPercent = ((cx - parentLeft) / parentWidth);
                const topPercent = ((cy - parentTop) / parentHeight);
                imageBig.css('left', "-" + ((imageBig.width() - parentWidth) * leftPercent) + "px");
                imageBig.css('top', "-" + ((imageBig.height() - parentHeight) * topPercent) + "px");
            }


            $(this).append(imageBig);
            window.setTimeout(() => {
                mMove(e);
            }, 10);


            imageBig.on('mousemove', function (e) {
                mMove(e)
            });

            imageBig.on('mouseout', function () {
                imageBig.remove();
            });
            /*  } else {
                  const parent = $(this).parent();
                  parent.prependTo(parent.parent());
              }
  */

            return false;
        });

        if ($('.woocommerce-tabs').length > 0) {
            $('.woocommerce-product-details__short-description-readmore ').on('click', function (e) {
                $('html,body').animate({ 'scrollTop': ($('.woocommerce-tabs').offset().top - 40) + 'px' }, 500);


            });
        } else if ($('.woocommerce-product-details__short-description-readmore ').length > 0) {
            $('.woocommerce-product-details__short-description-readmore ').remove();
        }


        // add to cart
        $(document.body).on('added_to_cart', function (e, obj) {

            $('.mainHeader__cartTotal').html(obj['cartTotal']);
            $('.miniCartContent').addClass('show');
            $('.miniCartContent').html(obj['div.widget_shopping_cart_content']);
            window.setTimeout(function () {
                $('.miniCartContent').removeClass('show');
            }, 3000);
        });

        //remove from cart
        $(document.body).on('removed_from_cart', (e, obj) => {
            $('.miniCartContent').html(obj['div.widget_shopping_cart_content']);
            $('.mainHeader__cartTotal').html(obj['cartTotal']);
        });
        // single page add to cart
        $(document).on('click', '.single_add_to_cart_button', function (e) {
            if (wc_add_to_cart_params) {
                e.preventDefault();

                var $thisbutton = $(this),
                    $form = $thisbutton.closest('form.cart'),
                    id = $thisbutton.val(),
                    product_qty = $form.find('input[name=quantity]').val() || 1,
                    product_id = $form.find('input[name=product_id]').val() || id,
                    variation_id = $form.find('input[name=variation_id]').val() || 0,
                    product_options = $form.parent().find("input[name='product_options[]']:checked").map(function () {
                        return $(this).val();
                    }).get().join(',') || null;
                // var product_optionsStatus = $form.parent().find("input[name='product_options[]']").length > 0 ? true : false;



                var data = {
                    action: 'woocommerce_ajax_add_to_cart',
                    product_id: product_id,
                    product_sku: '',
                    quantity: product_qty,
                    variation_id: variation_id,
                    product_options: product_options,
                };



                $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

                $.ajax({
                    type: 'post',
                    url: wc_add_to_cart_params.ajax_url,
                    data: data,
                    beforeSend: function (response) {
                        $thisbutton.removeClass('added').addClass('loading');
                    },
                    complete: function (response) {
                        $thisbutton.addClass('added').removeClass('loading');
                    },
                    success: function (response) {

                        if (response.error && response.product_url) {
                            window.location = response.product_url;
                            return;
                        } else {
                            window.setTimeout(() => {
                                $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                            }, 10);

                        }
                    },
                });

                return false;
            }
        });




        //add quantity buttons
        const quantityWc = new wcQuantity();

        $(document.body).on('updated_wc_div', () => { quantityWc.init() });

        quantityWc.init();






        //fancybox
        const fcbChck = document.querySelectorAll(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.fancybox a");

        if (fcbChck.length > 0) {
            let scriptF = document.createElement("script");
            scriptF.setAttribute("src", window.location.origin + "/wp-content/themes/seosem24/plugins/fancybox/jquery.fancybox.min.js");
            document.body.appendChild(scriptF);
            let cssF = document.createElement("link");
            cssF.setAttribute("rel", 'stylesheet');
            cssF.setAttribute("href", window.location.origin + "/wp-content/themes/seosem24/plugins/fancybox/jquery.fancybox.min.css");
            document.body.appendChild(cssF);

            scriptF.addEventListener("load", () => {

                $(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.fancybox a").fancybox({
                    'loop': true,
                    'margin': [44, 0],
                    'gutter': 50,
                    'keyboard': true,
                    'arrows': true,
                    'infobar': false,
                    'toolbar': true,
                    'buttons': ["slideShow", "fullScreen", "close"],
                    'idleTime': 4,
                    'protect': false,
                    'modal': false,
                    'animationEffect': "fade",
                    'animationDuration': 600,
                    'transitionEffect': "fade",
                    'transitionDuration': 800,
                    backFocus: false,
                    thumbs: {
                        autoStart: true, // Display thumbnails on opening
                        hideOnClose: true, // Hide thumbnail grid when closing animation starts
                        parentEl: ".fancybox-container", // Container is injected into this element
                        axis: window.innerWidth > 782 ? "y" : "x" // Vertical (y) or horizontal (x) scrolling
                    }
                });
            });

        }




    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



